export const DEFAULT_CALENDAR_COLOR = '#f87171';

export const LAYOUT = {
    COMPACT: 'compact',
    EXPANDED: 'expanded',
} as const;

export const LAYOUT_LABEL = {
    [LAYOUT.COMPACT]: 'Compact',
    [LAYOUT.EXPANDED]: 'Expanded',
} as const;

export const VIEW = {
    DAY: 'day',
    WEEK: 'week',
    MONTH: 'month',
} as const;

export const VIEW_LABEL = {
    [VIEW.DAY]: 'Day',
    [VIEW.WEEK]: 'Week',
    [VIEW.MONTH]: 'Month',
} as const;

export const CALENDAR_FIELD = {
    ID: 'id',
    CALENDAH: 'calendah',
    PROVIDER: 'provider',
    LOCATION: 'location',
    OBJECT: 'object',
    LABEL: 'label',
    COLOR: 'color',
    START_FIELD: 'startField',
    END_FIELD: 'endField',
    FILTER: 'filter',
    OBJECT_LABEL: 'objectLabel',
    RECORD_LABEL: 'recordLabel',
    DETAILS_LABEL: 'detailsLabel',
    DETAILS_FIELDS: 'detailsFields',
    FIELDS: 'fields',
    TYPE: 'type',
    SHARE_SCOPE: 'shareScope',
    SHARE_PERMISSION: 'sharePermission',
    SHARED_USERS: 'sharedUsers',
    CREATED_BY: 'createdBy',
    CREATED_AT: 'createdAt',
    UPDATED_AT: 'updatedAt',
} as const;

export const VIEW_FIELD = {
    ID: 'id',
    CALENDAR: 'calendar',
    POSITION: 'position',
    LABEL: 'label',
    ACTIVE: 'active',
    COLOR: 'color',
    CREATED_BY: 'createdBy',
    CREATED_AT: 'createdAt',
    UPDATED_AT: 'updatedAt',
} as const;

export const CALENDAR_SHARE_SCOPE = {
    PRIVATE: 'private',
    PORTAL: 'portal',
    USERS: 'users',
    PUBLIC: 'public',
} as const;

export const CALENDAR_SHARE_SCOPE_LABEL = {
    [CALENDAR_SHARE_SCOPE.PRIVATE]: 'Private',
    [CALENDAR_SHARE_SCOPE.PORTAL]: 'Portal-based',
    [CALENDAR_SHARE_SCOPE.USERS]: 'User-specific',
    [CALENDAR_SHARE_SCOPE.PUBLIC]: 'Public',
} as const;

export const CALENDAR_SHARE_PERMISSION = {
    READ: 'read',
    WRITE: 'write',
} as const;

export const CALENDAR_SHARE_PERMISSION_LABEL = {
    [CALENDAR_SHARE_PERMISSION.READ]: 'View Only',
    [CALENDAR_SHARE_PERMISSION.WRITE]: 'View & Edit',
} as const;

export const USER_FIELD = {
    ID: 'id',
    CALENDAH: 'calendah',
    USER: 'user',
    IS_OWNER: 'isOwner',
    IS_ACTIVE: 'isActive',
    PLATFORM_USER_ID: 'platformUserId',
    ACCESS_REQUEST: 'accessRequest',
    EMAIL: 'email',
    LAYOUT: 'layout',
    VIEW: 'view',
    FIRST_DAY_OF_WEEK: 'firstDayOfWeek',
    INCLUDE_WEEKENDS: 'includeWeekends',
    TIME_FORMAT: 'timeFormat',
    MONTHLY_EXTENDED_VIEW: 'monthlyExtendedView',
    MONTHLY_COMPACT_SHOW_ALL_RECORDS: 'monthlyCompactShowAllRecords',
    LAST_USED_AT: 'lastUsedAt',
    CREATED_AT: 'createdAt',
    UPDATED_AT: 'updatedAt',
} as const;

export const FIELD_FORMAT = {
    NUMBER: 'number',
    CURRENCY: 'currency',
    DROPDOWN: 'dropdown',
    DATETIME: 'datetime',
    DATE: 'date',
    STRING: 'string',
    HTML: 'html',
    OWNER: 'owner',
    USER: 'user',
} as const;

export const USER_SETTINGS = {
    LAYOUT: 'layout',
    VIEW: 'view',
    FIRST_DAY_OF_WEEK: 'firstDayOfWeek',
    INCLUDE_WEEKENDS: 'includeWeekends',
    TIME_FORMAT: 'timeFormat',
    MONTHLY_EXTENDED_VIEW: 'monthlyExtendedView',
    MONTHLY_COMPACT_SHOW_ALL_RECORDS: 'monthlyCompactShowAllRecords',
} as const;

export const TIME_FORMAT = {
    AUTO: 'auto',
    TWELVE_HOUR: '12h',
    TWENTY_FOUR_HOUR: '24h',
} as const;

export const TIME_FORMAT_OPTIONS = [
    {
        value: TIME_FORMAT.AUTO,
        label: 'Auto',
    },
    {
        value: TIME_FORMAT.TWELVE_HOUR,
        label: '12-hour (AM/PM)',
    },
    {
        value: TIME_FORMAT.TWENTY_FOUR_HOUR,
        label: '24-hour',
    },
] as const;
